import { AppPlatform } from '../platform';

export class PlatformData {
    platform: AppPlatform;
}
